import { useEffect, useState } from 'react';

const cliplisterScriptID = 'cliplister-script';
const cliplisterInstanceID = 'cliplister-instance';

export const addCliplisterScript = (scriptUrl: string) => {
  const cliplisterScript = document.getElementById(cliplisterScriptID);
  if (!cliplisterScript) {
    const script = document.createElement('script');
    script.setAttribute('src', scriptUrl);
    script.setAttribute('id', cliplisterScriptID);
    document.head.insertBefore(script, document.head.firstElementChild);
  }
};

export function removePlayerInstance() {
  const cliplisterInstanceElement = document.getElementById(cliplisterInstanceID);
  if (cliplisterInstanceElement) {
    cliplisterInstanceElement.remove();
  }
}

/**
 * orderNumber: get orderNumber from product api
 *
 * customerId: get customerId from config themes client
 *
 */
export const addPlayerInstance = (orderNumber: string, customerId: string) => {
  const cliplisterScriptElement = document.getElementById(cliplisterScriptID);

  if (cliplisterScriptElement) {
    removePlayerInstance();
    const playerInstance = document.createElement('script');
    playerInstance.setAttribute('id', cliplisterInstanceID);
    playerInstance.type = 'text/javascript';
    playerInstance.text = `
    var cliplisterGTMEvent = function(eventValue){
      if (typeof window !== 'undefined' && window['dataLayer'] && typeof eventValue !== 'undefined'){
        window['dataLayer'].push({
          event: 'ga_event',
          eventAction: 'viewVideo',
          eventCategory: 'cliplister',
          eventLabel: 'detailview',
          eventValue: eventValue,
        });
      }
    };

    var clViewer = new Cliplister.Viewer({
      parentId: "cliplister-viewer-${orderNumber}",
      customer: ${customerId},
      assetKeys: ["${orderNumber}"],
      keyType: 10000,
      stage: {
        width: "100%",
        aspectRatio: "asset"
      },
      plugins: {
        ClickableVideo: {
            layer: 1
        },
        InnerControls: {
            layer: 2,
            id: "controls",
            blacklist: ["share","quality","playback-speed"],
            template: {
                type: "external",
                source: "https://mycliplister.com/static/viewer/assets/skins/default/controls.html"
            }
        },
        BufferingSpinner: {
            layer: 3,
            width: 50,
            height: 50
        },
        PreviewImage: {
            layer: 4
        },
        PlayButton: {
            id: "playButton",
            layer: 5,
            image: 'https://mycliplister.com/static/viewer/assets/skins/default/playButton.png',
            width: 100,
            height: 100
        },
        NextButton: {
          layer: 6,
          timeAfterStart: 10,
          timeTillEnd: 10,
          visibility: "mouseover",
          template: "https://mycliplister.com/./static/viewer/assets/skins/empiriecom/next-button.html",
          position: {
              top: 8,
              right: 8
          }
        },
        AutoplayNext: {
          layer: 7,
          wait: 5
        }
      }
    });

    clViewer.onPlay(function(){
      cliplisterGTMEvent('start');
    }).onProgress20(function(){
      cliplisterGTMEvent('25');
    }).onProgress50(function(){
      cliplisterGTMEvent('50');
    }).onProgress70(function(){
      cliplisterGTMEvent('75');
    }).onProgress100(function(){
      cliplisterGTMEvent('100');
    });
    `;
    //  appends the player instance script created above directly after cliplister-script
    cliplisterScriptElement.parentNode!.insertBefore(
      playerInstance,
      cliplisterScriptElement.nextSibling,
    );
  }
};

// scoped two-way rendering to avoid hydration errors because of consent cookie dependecy
export const useRendered = () => {
  const [rendered, setRendered] = useState(false);
  useEffect(() => {
    setRendered(true);
  }, []);

  return rendered;
};
